// helpers/moveLayers.js

export function bringLayerForward(layersRef, drawCanvas, forceUpdateLayers) {
  const index = layersRef.current.findIndex((layer) => layer.isSelected);
  if (index >= 0 && index < layersRef.current.length - 1) {
    const [movedLayer] = layersRef.current.splice(index, 1);
    movedLayer.isSelected = true;
    layersRef.current.splice(index + 1, 0, movedLayer);
    drawCanvas();
    forceUpdateLayers();
  }
}

export function sendLayerBackward(layersRef, drawCanvas, forceUpdateLayers) {
  const index = layersRef.current.findIndex((layer) => layer.isSelected);
  if (index > 0) {
    const [movedLayer] = layersRef.current.splice(index, 1);
    movedLayer.isSelected = true;
    layersRef.current.splice(index - 1, 0, movedLayer);
    drawCanvas();
    forceUpdateLayers();
  }
}

/**
 * Bring the selected layer all the way to the top (front).
 */
export function sendLayerToTop(layersRef, drawCanvas, forceUpdateLayers) {
  const index = layersRef.current.findIndex((layer) => layer.isSelected);
  if (index >= 0 && index < layersRef.current.length - 1) {
    const [movedLayer] = layersRef.current.splice(index, 1);
    movedLayer.isSelected = true;
    layersRef.current.push(movedLayer);
    drawCanvas();
    forceUpdateLayers();
  }
}

/**
 * Send the selected layer all the way to the bottom (back).
 */
export function sendLayerToBottom(layersRef, drawCanvas, forceUpdateLayers) {
  const index = layersRef.current.findIndex((layer) => layer.isSelected);
  if (index > 0) {
    const [movedLayer] = layersRef.current.splice(index, 1);
    movedLayer.isSelected = true;
    layersRef.current.unshift(movedLayer);
    drawCanvas();
    forceUpdateLayers();
  }
}
